import React, {useEffect, useState} from "react";
import {BrowserRouter, Route, Switch} from "react-router-dom";
import {observer, useObserver} from "mobx-react-lite";
import {AuthChecker} from "../_core/AuthChecker";
import {Theme} from "../components/themes/Theme";
import {DashboardPage} from "../components/dashboard/DashboardPage";
import {LoginPage} from "../components/login/LoginPage";
import {ProfilePage} from "../components/profile/ProfilePage";
import {UserPage} from "../components/user/UserPage";
import {NewUser} from "../components/user/newUser/NewUser";
import {CompanyPage} from "../components/company/CompanyPage";
import {CompanyDetail} from "../components/company/companyDetail/CompanyDetail";
import {UpdateSubCompany} from "../components/company/updateSubCompany/UpdateSubCompany";
import {AddSubCompany} from "../components/company/addSubCompany/AddSubCompany";
import {NewCompany} from "../components/company/newCompany/NewCompany";
import {OnboardingCompanyDetail} from "../components/company/onboardingCompanyDetail/OnboardingCompanyDetail";
import {UserDetail} from "../components/user/userDetail/UserDetail";
import {CourierPage} from "../components/courier/CourierPage";
import {MultipleDedication} from "../components/courier/MultipleDedication/MultipleDedication";
import {CourierDetail} from "../components/courier/courierDetail/CourierDetail";
import {NewCourier} from "../components/courier/newCourier/NewCourier";
import {OrderDetail} from "../components/order/orderDetail/OrderDetail";
import {OrderPage} from "../components/order/OrderPage";
import {NewRequest} from "../components/newRequest/NewRequest";
import {ReportsPage} from "../components/reports/ReportsPage";
import {CourierDedication} from "../components/company/courierDedication/CourierDedication";
import {Region} from "../components/regions/Regions/Region";
import {MergeOptions} from "../components/company/companyDetailOptions/MergeOptions";
import {QueueOptions} from "../components/company/companyDetailOptions/QueueOptions";
import ShiftOptions from "../components/company/companyDetailOptions/ShiftOptions/ShiftOptions";
import {ProofOfDelivery} from "../components/company/companyDetailOptions/ProofOfDelivery";
import {SmsTrackingOptions} from "../components/company/companyDetailOptions/SmsTrackingOptions";
import {AppConfigPage} from "../components/appConfig/AppConfigPage";
import {Statistics} from "../components/statistics/StatisticsPage";
import {DynamicPriceOptions} from "../components/company/companyDetailOptions/DynamicPriceOptions";
import {DeliveryVerificationOptions} from "../components/company/companyDetailOptions/DeliveryVerificationOptions";
import {Heatmap} from "../components/heatMap/HeatMap";
import {SlotOrderOptions} from "../components/company/companyDetailOptions/SlotOrderOptions";
import {CourierStatisticsReportPage} from "../components/reports/courierStatisticsReport/CourierStatisticsReportPage";
import {OrderReportPage} from "../components/reports/orderReport/OrderReportPage";
import {LocationCheckOptions} from "../components/company/companyDetailOptions/LocationCheckOptions";
import BarcodeOptions from "../components/company/companyDetailOptions/BarcodeOptions/BarcodeOptions";
import ShiftManagement from "../components/shiftManagement/ShiftManagement";
import ShiftSuggestion from "../components/shiftSuggestion/ShiftSuggestion";
import ShiftScore from "../components/shiftScore/ShiftScore";
import {Objections} from "../components/shiftScore/objections/Objections";
import CutOffOptions from "../components/company/companyDetailOptions/CutOffOptions/CutOffOptions";
import {CourierShiftDetail} from "../components/courier/courierShiftDetail/courierShiftDetail";
import ShiftCompliance from "../components/shiftCompliance/ShiftCompliance";
import {ShiftSuggestionOptions} from "../components/company/companyDetailOptions/ShiftSuggestionOptions";
import {DayOff} from "../components/dayOff/DayOff";
import {QuickReactionCouriers} from "../components/quickReactionCouriers/QuickReactionCouriers";
import {message} from "antd";
import stores from "../store/stores";
import {PaymentManagement} from "../components/paymentManagement/PaymentManagement";
import AuthorizationManagement from "../components/user/AuthorizationManagement";
import {UserAuthorization} from "../components/user/userAuthorization/UserAuthorization";
import NewPool from "../components/pools/newPool/NewPool";
import PoolDetail from "../components/pools/poolDetail/PoolDetail";
import EditPool from "../components/pools/editPool/EditPool";
import EditPoolCouriers from "../components/pools/editPoolCouriers/EditPoolCouriers";
import Pools from "../components/pools/pools/Pools";
import {CreateDeliveryRequest} from "../components/createDeliveryRequest/CreateDeliveryRequest";
import {ShiftRequest} from "../components/shiftRequest/ShiftRequest";
import {ShiftRequestManagement} from "../components/shiftRequestManagement/ShiftRequestManagement";
import {SubCompanyPaymentContractList} from "../components/company/subCompanyDetail/subCompanyPaymentContracts/SubCompanyPaymentContractList";
import {CreditLogTable} from "../components/credits/CreditLogTable";
import {ObjectionPage} from "../components/company/objection/ObjectionPage";
import {CariList} from "../components/cari/CariList";
import CustomerHomePage from "../components/customer/customerHomePage/CustomerHomePage";
import CustomerOrdersPage from "../components/customer/customerOrdersPage/CustomerOrdersPage";
import CustomerAccountingPage from "../components/customer/customerAccountingPage/CustomerAccountingPage";
import CustomerProfilePage from "../components/customer/customerProfilePage/CustomerProfilePage";
import CustomerManualDeliveryPage from "../components/customer/customerManualDeliveryPage/CustomerManualDeliveryPage";
import CustomerCourierDailyOperationsPage from "../components/customer/customerCourierDailyOperationsPage/CustomerCourierDailyOperationsPage";
import CustomerOrderDetailPage from "../components/customer/customerOrderDetailPage/CustomerOrderDetailPage";
import {CustomerContractPage} from "../components/customer/customerContractPage/CustomerContractPage";
import {FalseCompanyRecords} from "../components/company/falseCompanyRecords/FalseCompanyRecords";
import ShiftManagementSnapshot from "../components/shiftManagementSnapshot/ShiftManagementSnapshot";
import DailyPoolForecasts from "../components/pools/dailyPoolForecasts/DailyPoolForecasts";
import DailyPoolSlots from "../components/pools/dailyPoolSlots/DailyPoolSlots";
import PoolShiftManagement from "../components/pools/poolShiftManagement/PoolShiftManagement";
import PoolCourierShifts from "../components/pools/poolCourierShifts/PoolCourierShifts";
import PoolCancelRequests from "../components/pools/poolCancelRequests/PoolCancelRequests";
import EditPoolUsers from "../components/pools/editPoolUsers/EditPoolUsers";
import {CariListDetail} from "../components/cari/CariListDetail/CariListDetail";
import {SubcompanyPage} from "../components/subcompany/SubcompanyPage";
import {SubCompanyDetailWithTab} from "../components/company/subCompanyDetailWithTab/SubCompanyDetailWithTab";
import PoolIntensities from "../components/pools/poolIntensities/PoolIntensities";
import Payments from "../components/payments/Payments";
import {AvailableCouriers} from "../components/availableCouriers/AvailableCouriers";
import {NewPasswordRedesign} from "../components/newPassword/NewPasswordRedesign";
import TransferPage from "../components/transfer/TransferPage";
import PlanningDraft from "../components/transfer/planningDraft/PlanningDraft";
import CalculatedTransfer from "../components/transfer/calculatedTransfer/CalculatedTransfer";
import TransferGrouping from "../components/transfer/transferGrouping/TransferGrouping";
import {ActiveTransfers} from "../components/transfer/activeTransfers/ActiveTransfers";
import TransferActivities from "../components/transfer/transferActivities/TransferActivities";
import {CODPaymentOptions} from "../components/company/companyDetailOptions/CODPaymentOptions";
import {ReadyOrderNotification} from "../components/company/companyDetailOptions/readyOrderNotification";
import {EditSupplierPage, SupplierPage} from "../components/supplierPage";
import {IntegratorPage} from "../components/integrationPage";
import PoolPaymentContracts from "../components/pools/poolPaymentContracts/poolPaymentContract";
import {BackofficeCashOnDeliveryPage} from "../components/cashOnDelivery/backoffice/BackofficeCashOnDeliveryPage";
import CustomerCashOnDeliveryPage from "../components/customer/customerCashOnDeliveryPage/CustomerCashOnDeliveryPage";
import {ContractTemplateManagement} from "../components/contract/contractTemplateManagement";
import ShipmentActivitiesDetail from "../components/transfer/shipmentActivitiesDetail/ShipmentActivitiesDetail";
import {CourierTerminalListPage} from "../components/cashOnDelivery/backoffice/courierTerminals/CourierTerminalListPage";
import UndeliveredShipments from "../components/transfer/undeliveredShipments/UndeliveredShipments";
import {PoolCourierBonusCampaigns} from "../components/pools/poolCourierBonusCampaigns/PoolCourierBonusCampaigns";
import TransferCenterList from "../components/transfer/transferCenterList/TransferCenterList";
import NewTransferCenter from "../components/transfer/newTransferCenter/NewTransferCenter";
import TransferDashboard from "../components/transfer/transferDashboard/TransferDashboard";
import PoolMergeOptions from "../components/pools/poolMergeOptions/poolMergeOptions";
import {CourierWalletListPage} from "../components/wallet/couriers/courierWalletListPage/CourierWalletListPage";
import {InactiveCourierWalletListPage} from "../components/wallet/couriers/inactiveCourierWalletListPage/InactiveCourierWalletListPage";
import PoolSupporter from "../components/pools/components/poolSupporter/PoolSupporter";
import {BackOfficeCODPastPeriodsPage} from "../components/cashOnDelivery/pastPeriods/backOfficeCODPastPeriodsPage/BackOfficeCODPastPeriodsPage";
import {MerchantCODPastPeriodsPage} from "../components/cashOnDelivery/pastPeriods/merchantCODPastPeriodsPage/MerchantCODPastPeriodsPage";
import {BackofficePaymentSummaryPage} from "../components/cashOnDelivery/summary/BackofficePaymentSummaryPage";
import {WalletCourierFinancialUploads} from "../components/wallet/WalletCourierFinancialUploads";
import {SubcompanyCodPaymentListPage} from "../pages/codPayment/SubcompanyCodPaymentListPage";
import { EditIntegratorPage } from "components/integrationPage/EditIntegrator/EditIntegratorPage";

const Routes = observer(() => {
    const [messageApi, contextHolder] = message.useMessage();
    const [msg, setMsg] = useState("");

    const success = id => {
        messageApi.open({
            type: "success",
            content: id
        });
    };

    document.addEventListener("click", event => {
        if (
            (event.ctrlKey || event.metaKey) &&
            event.target.closest("tr") &&
            stores.meStore.checkRole("isAdmin")
        ) {
            const row = event.target.closest("tr");
            const tempInput = document.createElement("input");
            tempInput.value = row.getAttribute("data-row-key");
            document.body.appendChild(tempInput);
            tempInput.select();
            document.execCommand("copy");
            document.body.removeChild(tempInput);
            if (row.hasAttribute("data-row-key")) {
                setMsg(row.getAttribute("data-row-key"));
            }
        }
    });

    useEffect(() => {
        if (msg !== "") {
            success(msg);
        }
    }, [msg]);
    return useObserver(() => (
        <BrowserRouter basename={"/panel"}>
            {contextHolder}
            <Theme>
                <Switch>
                    <Route exact path="/login" render={props => <LoginPage {...props} />} />
                    <Route
                        exact
                        path="/map"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hr",
                                    "hrEmployment",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing"
                                ]}
                                RenderComponent={DashboardPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/onboardingCompany"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "cUser", "oUser", "fieldManager"]}
                                RenderComponent={OnboardingCompanyDetail}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/false-records"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "fieldManager",
                                    "data",
                                    "software"
                                ]}
                                RenderComponent={FalseCompanyRecords}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/new"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "software", "oUser"]}
                                RenderComponent={NewCompany}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/edit/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={NewCompany}
                                roles={["admin", "superadmin", "software", "oUser"]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/add-sub-company/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={AddSubCompany}
                                roles={["admin", "superadmin", "software", "oUser"]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/sub-company/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SubCompanyDetailWithTab}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/sub-company/payment-contract/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SubCompanyPaymentContractList}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/suppliers/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={SupplierPage}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/integrators"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser"
                                ]}
                                RenderComponent={IntegratorPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/update-sub-company/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={UpdateSubCompany}
                                roles={["admin", "superadmin", "software", "oUser"]}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/dedication/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CourierDedication}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/merge-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={MergeOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/queue-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={QueueOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/shift-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ShiftOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/proof-of-delivery/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ProofOfDelivery}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/sms-tracking-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SmsTrackingOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/cod-payment-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CODPaymentOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/ready-order-notification-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ReadyOrderNotification}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/delivery-verification-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={DeliveryVerificationOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/delivery-slot-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={SlotOrderOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/dynamic-price-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={DynamicPriceOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/location-check-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={LocationCheckOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/shift-suggestion-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={ShiftSuggestionOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/barcode-options/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={BarcodeOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/cut-off/:companyId"
                        render={props => (
                            <AuthChecker
                                RenderComponent={CutOffOptions}
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "software",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "data"
                                ]}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "software"
                                ]}
                                RenderComponent={CompanyDetail}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/companies"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "software"
                                ]}
                                RenderComponent={CompanyPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/subcompanies"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "operationSupport",
                                    "operationImproving",
                                    "oUser",
                                    "fieldManager",
                                    "data",
                                    "software"
                                ]}
                                RenderComponent={SubcompanyPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/shiftdetail"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin"]}
                                RenderComponent={CourierShiftDetail}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/new"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "hr", "software", "oUser"]}
                                RenderComponent={NewCourier}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/multiple-dedication"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "hr", "software", "oUser"]}
                                RenderComponent={MultipleDedication}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/edit/:courierId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "hr", "software", "oUser"]}
                                RenderComponent={NewCourier}
                                courierId={props.match.params.courierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers/:courierId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "hrEmployment",
                                    "operationSupport",
                                    "operationImproving",
                                    "software",
                                    "data",
                                    "cUser",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager"
                                ]}
                                RenderComponent={CourierDetail}
                                courierId={props.match.params.courierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "hrEmployment",
                                    "operationSupport",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "cUser",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager"
                                ]}
                                RenderComponent={CourierPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/available-couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation"
                                ]}
                                RenderComponent={AvailableCouriers}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/orders/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hrEmployment",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "oUser",
                                    "sOperation",
                                    "software",
                                    "marketing",
                                    "finance"
                                ]}
                                RenderComponent={OrderDetail}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/orders"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "hrEmployment",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing"
                                ]}
                                RenderComponent={OrderPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/new-transfer-center"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={NewTransferCenter}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-center"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={TransferCenterList}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/undelivered-shipments"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={UndeliveredShipments}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-activities"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={TransferActivities}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/shipment-activities/:shipmentId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={ShipmentActivitiesDetail}
                                shipmentId={props.match.params.shipmentId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/active-transfers"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={ActiveTransfers}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-grouping"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={TransferGrouping}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/calculated-transfer"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={CalculatedTransfer}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/transfer-rotate"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={PlanningDraft}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers/dashboard"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={TransferDashboard}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/transfers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "operationSupport",
                                    "oUser"
                                ]}
                                RenderComponent={TransferPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/new"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={NewUser}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/authorization-management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={AuthorizationManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/users/edit/:userId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={NewUser}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users/authorization/:userId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin"]}
                                RenderComponent={UserAuthorization}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users/:userId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={UserDetail}
                                {...props}
                                userId={props.match.params.userId}
                            />
                        )}
                    />
                    <Route
                        path="/users"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "data",
                                    "operationImproving",
                                    "software"
                                ]}
                                RenderComponent={UserPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/profile"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "cUser",
                                    "hr",
                                    "hrEmployment",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing"
                                ]}
                                RenderComponent={ProfilePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/password-reset"
                        render={props => (
                            <NewPasswordRedesign token={props.match.params.token} {...props} />
                        )}
                    />
                    <Route
                        path="/third-party-request/new/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "cUser"
                                ]}
                                RenderComponent={NewRequest}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/third-party-request/new/"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser",
                                    "oUser"
                                ]}
                                RenderComponent={NewRequest}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/create-delivery-request"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser",
                                    "oUser",
                                    "sOperation"
                                ]}
                                RenderComponent={CreateDeliveryRequest}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-request/management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser"
                                ]}
                                RenderComponent={ShiftRequestManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-request"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "cUser",
                                    "oUser"
                                ]}
                                RenderComponent={ShiftRequest}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/credit-logs/cari-list/:subCompanyId"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={CariListDetail}
                                subCompanyId={props.match.params.subCompanyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/credit-logs/cari-list"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={CariList}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/credit-logs"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={CreditLogTable}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/past-periods"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "finance"
                                ]}
                                RenderComponent={BackOfficeCODPastPeriodsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/subCompanies"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport", "oUser"]}
                                RenderComponent={SubcompanyCodPaymentListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/courier-terminals"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "finance"
                                ]}
                                RenderComponent={CourierTerminalListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery/cash-on-delivery-summary"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "finance"
                                ]}
                                RenderComponent={BackofficePaymentSummaryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/cash-on-delivery"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "finance"
                                ]}
                                RenderComponent={BackofficeCashOnDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/packet-objection"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "cUser"
                                ]}
                                RenderComponent={ObjectionPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/courierStatistics"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "fieldManager",
                                    "sOperation"
                                ]}
                                RenderComponent={CourierStatisticsReportPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/order"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager"
                                ]}
                                RenderComponent={OrderReportPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-score/objections"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "cUser", "oUser", "fieldManager"]}
                                RenderComponent={Objections}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-score"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager"
                                ]}
                                RenderComponent={ShiftScore}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports/shift-compliance"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "cUser",
                                    "oUser",
                                    "fieldManager",
                                    "sOperation"
                                ]}
                                RenderComponent={ShiftCompliance}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/reports"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "finance",
                                    "hr",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager",
                                    "data",
                                    "operationImproving",
                                    "software",
                                    "marketing",
                                    "cUser"
                                ]}
                                RenderComponent={ReportsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/regions"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "operationSupport"]}
                                RenderComponent={Region}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/appconfig"
                        render={props => (
                            <AuthChecker
                                roles={["superadmin"]}
                                RenderComponent={AppConfigPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/statistics"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "cUser",
                                    "oUser",
                                    "sOperation",
                                    "fieldManager"
                                ]}
                                RenderComponent={Statistics}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/heatmap"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager"
                                ]}
                                RenderComponent={Heatmap}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management/snapshot"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager"
                                ]}
                                RenderComponent={ShiftManagementSnapshot}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management/day-off"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager"
                                ]}
                                RenderComponent={DayOff}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management/quick-reaction-couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager"
                                ]}
                                RenderComponent={QuickReactionCouriers}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-management"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "fieldManager",
                                    "sOperation"
                                ]}
                                RenderComponent={ShiftManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/shift-suggestion"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "oUser",
                                    "sOperation"
                                ]}
                                RenderComponent={ShiftSuggestion}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/payment-management"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "finance"]}
                                RenderComponent={PaymentManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/contract-management"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={ContractTemplateManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/edit-supplier/:supplierId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditSupplierPage}
                                supplierId={props.match.params.supplierId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/edit-integrator/:integratorId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditIntegratorPage}
                                integratorId={props.match.params.integratorId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/new-supplier/:companyId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditSupplierPage}
                                companyId={props.match.params.companyId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/new-integrator"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "operationSupport"]}
                                RenderComponent={EditIntegratorPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/new"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={NewPool}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/shift-management"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={PoolShiftManagement}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/intensities"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={PoolIntensities}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/courier-shifts"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={PoolCourierShifts}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/shift-cancel-requests"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={PoolCancelRequests}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/courier-bonus-campaigns"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={PoolCourierBonusCampaigns}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/edit"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={EditPool}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/couriers"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation", "sOperation"]}
                                RenderComponent={EditPoolCouriers}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/authorized-users"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={EditPoolUsers}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/payment-contracts"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={PoolPaymentContracts}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/support-pool-settings"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={PoolSupporter}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path="/pools/:poolId/merge-options"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser"]}
                                RenderComponent={PoolMergeOptions}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/daily-forecasts"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={DailyPoolForecasts}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId/daily-slots"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation"]}
                                RenderComponent={DailyPoolSlots}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools/:poolId"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation", "sOperation"]}
                                RenderComponent={PoolDetail}
                                poolId={props.match.params.poolId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/pools"
                        render={props => (
                            <AuthChecker
                                roles={["admin", "superadmin", "oUser", "sOperation", "sOperation"]}
                                RenderComponent={Pools}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/payments"
                        render={props => (
                            <AuthChecker roles={["cUser"]} RenderComponent={Payments} {...props} />
                        )}
                    />
                    <Route
                        path="/wallet/couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "operationSupport",
                                    "finance"
                                ]}
                                RenderComponent={CourierWalletListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/wallet/inactive-couriers"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "oUser",
                                    "operationSupport",
                                    "finance"
                                ]}
                                RenderComponent={InactiveCourierWalletListPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/wallet/courier-financial-uploads"
                        render={props => (
                            <AuthChecker
                                roles={[
                                    "admin",
                                    "superadmin",
                                    "operationSupport",
                                    "software",
                                    "oUser",
                                    "cUser",
                                    "finance"
                                ]}
                                RenderComponent={WalletCourierFinancialUploads}
                                {...props}
                            />
                        )}
                    />

                    <Route
                        path="/musteri/kapida-odeme/gecmis-donemler"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={MerchantCODPastPeriodsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/kapida-odeme"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerCashOnDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/siparislerim/:deliveryId"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerOrderDetailPage}
                                deliveryId={props.match.params.deliveryId}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/siparislerim"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerOrdersPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/muhasebe"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerAccountingPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/sozlesme"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerContractPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/manuel-gonderi-olustur"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerManualDeliveryPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/kurye-gunluk-islemleri"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerCourierDailyOperationsPage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/duyurular"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerHomePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri/hesabim"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerProfilePage}
                                {...props}
                            />
                        )}
                    />
                    <Route
                        path="/musteri"
                        render={props => (
                            <AuthChecker
                                roles={["cUser"]}
                                RenderComponent={CustomerHomePage}
                                {...props}
                            />
                        )}
                    />
                    <Route path="*" render={props => <AuthChecker roles={[]} {...props} />} />
                </Switch>
            </Theme>
        </BrowserRouter>
    ));
});

export default Routes;
